var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
var formSerializer = function (data, headers) {
    var formData = new FormData();
    for (var key in data) {
        formData.append(key, data[key]);
    }
    headers.set('Content-Type', 'application/x-www-form-urlencoded');
    return { body: formData, headers: headers };
};
var CREATE_DATASOURCE = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation createDatasource($input: any, $formSerializer: any) {\n    createDatasource: datasource(input: $input)\n      @rest(type: \"createDatasource\", method: \"POST\", path: \"/datasources\", bodySerializer: $formSerializer) {\n      id\n      name\n      tables {\n        datasourceId\n        name\n        counts\n      }\n    }\n  }\n"], ["\n  mutation createDatasource($input: any, $formSerializer: any) {\n    createDatasource: datasource(input: $input)\n      @rest(type: \"createDatasource\", method: \"POST\", path: \"/datasources\", bodySerializer: $formSerializer) {\n      id\n      name\n      tables {\n        datasourceId\n        name\n        counts\n      }\n    }\n  }\n"])));
export default CREATE_DATASOURCE;
var templateObject_1;
